<select class="input minimal" (change)="addTypeFilter($event)" [value]="SelectedValetType">
  <option value="">All Guest Types</option>
  @for (i of ValetTypes; track i) {
    <option [selected]="ValetTypeSelected(i)" [value]="i.Id.toString()">{{i.Name}}
    </option>
  }
</select>
